import { Routes } from '@angular/router';
// Guard
import { AuthGuard } from '../_guards/auth.guard';
import { AccessGuard } from '../_guards/access.guard';
// component imports
import { BoardApprovalComponent } from './component/board-approval/board-approval.component';
// Constant imports
import { CiraHelpKeyConstants } from '../_constants/cira-help-key-constants';
const ɵ0 = { pageTitle: 'Board Approvals', helpKey: CiraHelpKeyConstants.boardApproval };
const boardApprovalRoutes = [
    {
        path: '',
        component: BoardApprovalComponent,
        data: ɵ0,
        canActivate: [AuthGuard, AccessGuard]
    },
    { path: '**', pathMatch: 'full', redirectTo: '/home' }
];
export class BoardApprovalRoutingModule {
}
export { ɵ0 };
